import getQuickShopHistoryProductsSelect from 'modules/product/redux/selectors/get-quick-shop-history'
import { createSelector } from 'reselect'

const getPreviousHistoryItemProductsSelect = createSelector(
  getQuickShopHistoryProductsSelect,
  productsHistory => productsHistory?.length > 1
    ? productsHistory[productsHistory.length - 2]
    : undefined
)

export default getPreviousHistoryItemProductsSelect
